import _ from 'lodash';


const internalise = (maxCount, count) => {
	const diff = Math.abs(maxCount - count);
	let unit = '';

	if (diff === 1) {
		unit = 'запись';
	}

	if (diff >= 2) {
		unit = 'записи';
	}

	if (diff >= 5) {
		unit = 'записей';
	}

	return `Показать еще ${diff} ${unit}`;
};

const throwError = error => {
	setTimeout(() => {
		throw error;
	}, 10);
};

const safer = asyncCallable => (...args) => {
	try {
		return asyncCallable(...args)
			.catch(e => {
				throwError(e);
			});
	} catch (e) {
		throwError(e);
	}
};

const isLikePromise = (obj) => _.isFunction(obj.then);

const COMPOSE_IS_STOPPED = '#stop';
const fpComposeAsync = (...fns) => start => {
	const result = fns.reduceRight((state, fn) => {
		const p = isLikePromise(state) ? state : Promise.resolve(state);

		return p.then((...args) => {
			const next = fn(...args);

			if (next === COMPOSE_IS_STOPPED) {
				throw new Error(COMPOSE_IS_STOPPED);
			}

			return next;
		});
	}, Promise.resolve(start));

	return result.catch(e => {
		if (e.message !== COMPOSE_IS_STOPPED) {
			throwError(e);
		}
	});
};
fpComposeAsync.breakChain = () => COMPOSE_IS_STOPPED;



export {internalise, fpComposeAsync, safer};
